import MultipleChoice from "./MultipleChoice";
import InfoTooltip from "./InfoTooltip";
import {FaMusic} from "react-icons/fa";
import { useViewMode } from "../contexts/ViewModeContext";
import { useCustomAuth } from "../contexts/AuthContext";
import { isUnknownTrack } from "../utils/constants";

export const InstrumentMenuOptions = [
    // {
    //     label: "Unknown Instrument (未知乐器)",
    //     children: [
    //         { label: "Unknown Instrument (未知乐器)", img_path: null }
    //     ]
    // },
    {
        label: "Vocal (人声)",
        children: [
            {
                label: "Lead Vocal (主人声)",
                children: [
                    { label: "Male Lead Vocal (男声主人声)", img_path: "Male.svg" },
                    { label: "Female Lead Vocal (女声主人声)", img_path: "Female.svg" }
                ]
            },
            {
                label: "Backing Vocals (人声和声)",
                children: [
                    { label: "Male Background Vocals (男声和声)", img_path: "Male.svg" },
                    { label: "Female Background Vocals (女声和声)", img_path: "Female.svg" },
                    { label: "Mixed Background Vocals (男女混合和声)", img_path: "Choir.svg" }
                ]
            },
            {
                label: "Choir (合唱团)",
                children: [
                    { label: "Male Choir (男声合唱团)", img_path: "Choir.svg" },
                    { label: "Female Choir (女声合唱团)", img_path: "Choir.svg" },
                    { label: "Mixed Choir (男女混合合唱团)", img_path: "Choir.svg" }
                ]
            },
            {
                label: "Children's Voice (童声)",
                children: [
                    { label: "Boy (男声童声)", img_path: "Children.svg" },
                    { label: "Girl (女声童声)", img_path: "Children.svg" },
                    { label: "Children's Choir (童声合唱团)", img_path: "Choir.svg" }
                ]
            }
        ]
    },

    /* ───────── Keyboard ───────── */
    {
        label: "Keyboard (键盘)",
        children: [
            { label: "Acoustic Piano (原声钢琴)", img_path: "Piano.svg" },
            { label: "Electric Piano (电钢琴)", img_path: "Synthesizer.svg" },
            { label: "Harpsichord (羽管键琴)", img_path: "Harpsichord.svg" },
            { label: "Clavichord (击弦古钢琴)", img_path: "Clavichord.svg" },
            { label: "Fortepiano (古钢琴)", img_path: "Clavichord.svg" },
            { label: "Vintage Digital Keys (复古数字钢琴)", img_path: "Synthesizer.svg" },
            {
                label: "Organ (风琴)",
                children: [
                    { label: "Accordion (手风琴)", img_path: "Accordion.svg" },
                    { label: "Pipe Organ (管风琴)", img_path: "Pipe_Organ.svg" },
                    { label: "Harmonium (脚踏式风琴)", img_path: "Harmonium.svg" },
                    { label: "Melodica (口风琴)", img_path: "Melodica.svg" }
                ]
            }
        ]
    },

    /* ───────── Guitar ───────── */
    {
        label: "Guitar (吉他)",
        children: [
            { label: "Steel-String Acoustic Guitar (民谣吉他)", img_path: "Acoustic_Guitar.svg" },
            {
                label: "Electric Guitar (电吉他)",
                children: [
                    { label: "Clean Electric Guitar (清音电吉他)", img_path: "Electric_Guitar.svg" },
                    { label: "Distortion Guitar (失真电吉他)", img_path: "Electric_Guitar.svg" },
                    { label: "Overdriven Guitar (过载电吉他)", img_path: "Electric_Guitar.svg" }
                ]
            },
            { label: "Classical Guitar (古典吉他)", img_path: "Acoustic_Guitar.svg" },
            { label: "Ukulele (尤克里里)", img_path: "Ukulele.svg" }
        ]
    },

    /* ───────── Bass ───────── */
    {
        label: "Bass (贝斯)",
        children: [
            { label: "Electric Bass (电贝斯)", img_path: "Electric_Guitar.svg" },
            { label: "Synth Bass (合成器贝斯)", img_path: "Synthesizer.svg" },
            { label: "Acoustic Bass (原声贝斯)", img_path: "Acoustic_Guitar.svg" }
        ]
    },

    /* ───────── Percussion ───────── */
    {
        label: "Percussion (打击乐器)",
        children: [
            { label: "Drum Kit (架子鼓)", img_path: "Drum_Kit.svg" },
            { label: "Electric Drum (电子鼓)", img_path: "Electric_Drum.svg" },
            { label: "Timpani (定音鼓)", img_path: "Timpani.svg" },
            {
                label: "Pitched Percussion (有音高的打击乐)",
                children: [
                    { label: "Xylophone (木琴)", img_path: "Xylophone.svg" },
                    { label: "Marimba (马林巴)", img_path: "Xylophone.svg" },
                    { label: "Glockenspiel (钟琴)", img_path: "Xylophone.svg" },
                    { label: "Celesta (钢片琴)", img_path: "Xylophone.svg" },
                    { label: "Vibraphone (颤音琴)", img_path: "Xylophone.svg" },
                    { label: "Tubular Bells (管钟)", img_path: "Tubular_Bells.svg" }
                ]
            },
            {
                label: "Other Percussion (其他打击乐器)",
                children: [
                    { label: "Bell Tree (音树)", img_path: "Bell_Tree.svg" },
                    { label: "Bongo (邦戈鼓)", img_path: "Djembe.svg" },
                    { label: "Cajon (箱鼓)", img_path: "Cajon.svg" },
                    { label: "Clave (响捧)", img_path: "Clave.svg" },
                    { label: "Claps (拍手)", img_path: "Claps.svg" },
                    { label: "Conga (康加鼓)", img_path: "Djembe.svg" },
                    { label: "Cowbell (牛铃)", img_path: "Cowbell.svg" },
                    { label: "Crotales (响板)", img_path: "Crotales.svg" },
                    { label: "Cymbals (大镲)", img_path: "Cymbals.svg" },
                    { label: "Djembe (非洲鼓)", img_path: "Djembe.svg" },
                    { label: "Finger Cymbals (手指小镲)", img_path: "Cymbals.svg" },
                    { label: "Guiro (吉罗)", img_path: "Guiro.svg" },
                    { label: "Maracas (沙槌)", img_path: "Maracas.svg" },
                    { label: "Ratchet (齿轮剐响器)", img_path: "Ratchet.svg" },
                    { label: "Shekere (沙可利沙)", img_path: "Maracas.svg" },
                    { label: "Tambourine (铃鼓)", img_path: "Tambourine.svg" },
                    { label: "Timbales (天巴鼓)", img_path: "Timbales.svg" },
                    { label: "Triangle (三角铁)", img_path: "Triangle.svg" },
                    { label: "Whistle (哨)", img_path: "Whistle.svg" },
                    { label: "Wind Chimes (风铃)", img_path: "Bell_Tree.svg" },
                    { label: "Woodblock (木鱼)", img_path: "Woodblock.svg" }
                ]
            }
        ]
    },

    /* ───────── String ───────── */
    {
        label: "String (弦乐)",
        children: [
            { label: "Violin (小提琴)", img_path: "Violin.svg" },
            { label: "Viola (中提琴)", img_path: "Violin.svg" },
            { label: "Cello (大提琴)", img_path: "Violin.svg" },
            { label: "Double Bass (低音提琴)", img_path: "Violin.svg" },
            { label: "String Ensemble (弦乐合奏)", img_path: "String_Ensemble.svg" }
        ]
    },

    /* ───────── Brass ───────── */
    {
        label: "Brass (铜管)",
        children: [
            {
                label: "Trumpet Family (小号类)",
                children: [
                    { label: "Trumpets (小号)", img_path: "Trumpet.svg" },
                    { label: "Piccolo Trumpet (高音小号)", img_path: "Trumpet.svg" },
                    { label: "Flugelhorn (富鲁格号)", img_path: "Trumpet.svg" },
                    { label: "Cornet (短号)", img_path: "Trumpet.svg" }
                ]
            },
            { label: "French Horns (圆号)", img_path: "French_Horns.svg" },
            { label: "Trombones (长号)", img_path: "Trombones.svg" },
            { label: "Tuba (大号)", img_path: "Tuba.svg" },
            { label: "Euphonium (上低音号)", img_path: null },
            { label: "Baritone Horn (次中音号)", img_path: null }
        ]
    },

    /* ───────── Woodwinds ───────── */
    {
        label: "Woodwinds (木管)",
        children: [
            {
                label: "Saxophone (萨克斯类)",
                children: [
                    { label: "Soprano Saxophone (高音萨克斯)", img_path: "Saxophone.svg" },
                    { label: "Alto Saxophone (中音萨克斯)", img_path: "Saxophone.svg" },
                    { label: "Tenor Saxophone (次中音萨克斯)", img_path: "Saxophone.svg" },
                    { label: "Baritone Saxophone (上低音萨克斯)", img_path: "Saxophone.svg" },
                    { label: "Bass Saxophone (低音萨克斯)", img_path: "Saxophone.svg" },
                    { label: "Contrabass Saxophone (倍低音萨克斯)", img_path: "Saxophone.svg" }
                ]
            },
            { label: "Clarinet (单簧管)", img_path: "Clarinet.svg" },
            { label: "Bass Clarinet (低音单簧管)", img_path: "Clarinet.svg" },
            { label: "Oboe (双簧管)", img_path: "Oboe.svg" },
            { label: "English Horns (英国管)", img_path: "Oboe.svg" },
            { label: "Bassoon (巴松)", img_path: "Bassoon.svg" },
            { label: "Contrabassoon (倍低音巴松管)", img_path: "Bassoon.svg" },
            { label: "Harmonica (口琴)", img_path: "Harmonica.svg" },
            { label: "Flutes (长笛)", img_path: "Flutes.svg" },
            { label: "Piccolo (短笛)", img_path: "Flutes.svg" },
            { label: "Recorder (竖笛)", img_path: "Flutes.svg" },
            { label: "Pan Flute (排箫)", img_path: "Pan_Flute.svg" }
        ]
    },

    /* ───────── Synthesizer ───────── */
    {
        label: "Synthesizer (合成器)",
        children: [
            { label: "Synthesizer - Arpeggio (合成器 - 琶音)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Atmosphere (合成器 - 氛围)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Bell (合成器 - 铃)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Brass (合成器 - 铜管)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Chord (合成器 - 和弦)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Drumloop (合成器 - 鼓循环)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Drums (合成器 - 鼓组)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - FX Sound (合成器 - 音效)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Guitar (合成器 - 吉他)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Lead (合成器 - 主音)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Mallet (合成器 - 木槌)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Orchestra (合成器 - 管弦乐团)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Pads (合成器 - 铺底)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Plucked (合成器 - 弹拨)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Piano (合成器 - 钢琴)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Reed (合成器 - 簧片)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Strings (合成器 - 弦乐)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Vocal / Choir (合成器 - 人声/合唱)", img_path: "Synthesizer.svg" },
            { label: "Synthesizer - Woodwinds (合成器 - 木管)", img_path: "Synthesizer.svg" }
        ]
    },

    /* ───────── Medieval / World ───────── */
    {
        label: "Medieval / World Instruments (中世纪/世界乐器)",
        children: [
            { label: "Harp (竖琴)", img_path: "Harp.svg" },
            { label: "Rutchen (鲁特琴)", img_path: null },
            { label: "Sitar (西塔琴)", img_path: "Sitar.svg" },
            { label: "Theremin (特雷门琴)", img_path: null },
            { label: "Jew's Harp (口弦琴)", img_path: null },
            { label: "Viking Horn (维京号角)", img_path: null },
            { label: "Banjo (班卓琴)", img_path: "Banjo.svg" },
            { label: "Mandolin (曼陀林)", img_path: "Banjo.svg" },
            { label: "Bagpipe (风笛)", img_path: "Bagpipe.svg" },
            { label: "Tin Whistle (爱尔兰哨笛)", img_path: null },
            { label: "Ocarina (陶笛)", img_path: "Ocarina.svg" },
            { label: "Kalimba (卡林巴/拇指琴)", img_path: null },
            {
                label: "Traditional Japanese Instruments (日本民族乐器)",
                children: [
                    { label: "Koto (日本筝)", img_path: "Koto.svg" },
                    { label: "Shakuhachi (尺八)", img_path: null },
                    { label: "Shamisen (三味线)", img_path: null },
                    { label: "Taiko (太鼓)", img_path: null }
                ]
            }
        ]
    },

    /* ───────── Chinese Traditional ───────── */
    {
        label: "Chinese Traditional Instruments (中国民族乐器)",
        children: [
            { label: "Guzheng (古筝)", img_path: "Koto.svg" },
            { label: "Dizi (笛子)", img_path: "Flutes.svg" },
            { label: "Erhu (二胡/其他胡琴)", img_path: "Erhu.svg" },
            { label: "Pipa (琵琶)", img_path: "Pipa.svg" },
            { label: "Xiao (箫)", img_path: "Flutes.svg" },
            { label: "Suona (唢呐)", img_path: "Suona.svg" },
            { label: "Hulusi (葫芦丝)", img_path: "Hulusi.svg" },
            { label: "Matouqin (马头琴)", img_path: null },
            { label: "Sanxian (三弦)", img_path: null },
            { label: "Sheng (笙)", img_path: null },
            { label: "Ruan (阮)", img_path: null },
            { label: "Dulcimer (扬琴)", img_path: null },
            { label: "Bawu (巴乌)", img_path: null },
            { label: "Liuqin (柳琴)", img_path: null },
            { label: "Xun (埙)", img_path: null },
            { label: "Gong (锣)", img_path: "Cymbals.svg" },
            { label: "Cha (镲)", img_path: "Cymbals.svg" },
            { label: "Guqin (古琴)", img_path: "Koto.svg" },
            { label: "Bili (筚篥)", img_path: null },
            { label: "Bianzhong (编钟)", img_path: null },
            { label: "Kuaiban (快板)", img_path: null },
            { label: "Naobo (铙钹)", img_path: null },
            { label: "Tanggu (堂鼓)", img_path: null },
            { label: "Bangzi (梆子)", img_path: null },
            { label: "Xiangshi (响石)", img_path: null },
            { label: "Huapengu (花盆鼓)", img_path: null },
            { label: "Samangu (萨满鼓)", img_path: null },
            {
                label: "Uyghur Instruments (新疆维族乐器)",
                children: [
                    { label: "Dutar (都塔尔)", img_path: null },
                    { label: "Rawap (热瓦普)", img_path: null },
                    { label: "Satar (萨塔尔)", img_path: null },
                    { label: "Gijgk (艾捷克)", img_path: null },
                    { label: "Zurna (苏尔乃)", img_path: null },
                    { label: "Tanbur (弹波尔)", img_path: null },
                    { label: "Dombra (冬不拉)", img_path: null },
                    { label: "Diltar (迪里塔尔)", img_path: null },
                    { label: "Qalun (卡龙)", img_path: null },
                    { label: "Dap (达普)", img_path: null },
                    { label: "Naqara (纳格拉鼓)", img_path: null },
                    { label: "Tabla (塔布拉)", img_path: null }
                ]
            }
        ]
    }
];

// Extract all leaf node labels from InstrumentMenuOptions
export const extractLeafNodeLabels = () => {
    const leafLabels = [];
    
    const traverseOptions = (options) => {
        for (const option of options) {
            if (option.children && option.children.length > 0) {
                // If has children, recursively traverse them
                traverseOptions(option.children);
            } else {
                // If no children, this is a leaf node
                leafLabels.push(option.label);
            }
        }
    };
    
    traverseOptions(InstrumentMenuOptions);
    return leafLabels;
};

console.log('all leaf node labels: ', extractLeafNodeLabels());

export const InstrumentTrackInstruction = `请您严格按照宿主打开后乐轨的顺序，来添加乐器轨。为了节省您的时间，我们会用算法把MIDI中的乐器轨按顺序添加到标注页面中。但是，对于未知的乐器需要您自行判断和选择正确的乐器。由于算法的精确度问题，其中可能会出现一些纰漏，因此还需要您手动确认每一轨所选择的乐器有没有问题并修改！
Please strictly follow the track order as displayed in the DAW when opening the MIDI file to add instrument tracks. To save your time, we use an algorithm to automatically add instrument tracks to the annotation interface in this order based on the MIDI data. However, for instruments labeled as “Unknown,” you will need to manually identify and select the correct instrument.Due to limitations in the algorithm’s accuracy, errors may occur—so please manually verify and correct the instrument label for each track as needed.`

export const getDynamicIcon = (label) => {
    // Special case for Unknown Instrument - return red exclamation mark
    if (isUnknownTrack(label)) {
        return (
            <span style={{
                color: 'red',
                fontSize: '24px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%'
            }}>
                !
            </span>
        );
    }

    // find img_path
    const findImgPath = (options, target) => {
        for (const opt of options) {
            const optLabel = opt.label.split("(")[0].trim().toLowerCase();
            const tgtLabel = target.trim().toLowerCase();

            if (optLabel === tgtLabel) {
                return opt.img_path ?? null;
            }
            if (opt.children) {
                const child = findImgPath(opt.children, target);
                if (child) return child;
            }
        }
        return null;
    };

    const imgPath = findImgPath(InstrumentMenuOptions, label);

    // build <img> element if found
    if (imgPath) {
        return (
          <img
            src={require(`../assets/img/music_instruments/${imgPath}`)}
            alt={label}
            className="object-contain max-w-[30px] max-h-[30px] w-full h-full"
          />
        );
      }

    // No match default music
    return <FaMusic/>;
};

const InstrumentMenu = ({addNewTrack, buttonClassName}) => {
    const { isTrackEditMode } = useViewMode();
    const { isAdminMode } = useCustomAuth();

    return (
      <div className="h-full w-full flex items-center justify-center">
            <MultipleChoice
                questionText={""}
                label={"Instrument Menu"}
                options={InstrumentMenuOptions}
                mandatory={false}
                allowAnyLevelSelection={false}
                singleSelect={true}
                onSelect={(val) => {
                    addNewTrack(val[0], "instrument")
                }}
                className="w-full h-full bg-black text-white font-bold text-lg hover:bg-gray-800 transition-colors duration-200 flex items-center justify-center"
                customTrigger={
                    <div className="bg-black text-white p-2 rounded cursor-pointer w-48 text-center" style={{pointerEvents: !isAdminMode ? "none" : (isTrackEditMode ? "auto" : "none"), opacity: !isAdminMode ? 0.5 : (isTrackEditMode ? 1 : 0.5)}}>
                        <span className="mr-5">+</span>
                        <span>Add Track</span>
                        <InfoTooltip disabled={!isAdminMode || !isTrackEditMode} instruction={InstrumentTrackInstruction}/>
                    </div>
                }
            />
        </div>
    );
};

export default InstrumentMenu;
